"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpType = void 0;
const node_1 = require("./node");
/* eslint-disable no-unused-vars */
var OpType;
(function (OpType) {
    OpType["Add"] = "+";
    OpType["Subtract"] = "-";
    OpType["Multiply"] = "*";
    OpType["Divide"] = "/";
    OpType["Mod"] = "%";
})(OpType = exports.OpType || (exports.OpType = {}));
/* eslint-enable no-unused-vars */
class MathNode extends node_1.default {
    /* eslint-disable no-unused-vars */
    static from(obj, parse) {
        if (obj['type'] === 'math')
            return new MathNode(parse(obj['node1']), parse(obj['node2']), obj['op']);
        return null;
    }
    /* eslint-enable no-unused-vars */
    constructor(node1, node2, operator) {
        super();
        this.node1 = node1;
        this.node2 = node2;
        this.op = operator;
    }
    serialize() {
        return {
            type: 'math',
            node1: this.node1.serialize(),
            node2: this.node2.serialize(),
            op: this.op,
        };
    }
    validate() {
        if (!this.node1 || !this.node2)
            return false;
        return this.node1.validate() && this.node2.validate();
    }
    listColumns() {
        return this.node1.listColumns().concat(this.node2.listColumns());
    }
}
exports.default = MathNode;
